import { cn } from '@/lib/utils'
import React from 'react'

interface CountBadgeProps {
  count: number
  className?: string
}

/**
 * Small red pill showing a count of items needing attention (e.g. unexported
 * salary lines). Renders nothing when `count` is 0 or negative. A single digit
 * renders as a perfect circle; 2+ digits widen into a pill.
 */
export const CountBadge: React.FC<CountBadgeProps> = ({ count, className }) => {
  if (count <= 0) return null

  return (
    <span
      className={cn(
        'inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-error px-1 text-xs font-semibold leading-none text-white',
        className
      )}
    >
      {count}
    </span>
  )
}
